import Link from "next/link";
import { Layout } from "../../components/layout/layout.comp";
import { LongCopy } from "../../components/longCopy/longCopy.comp";

export default function C2PPage() {
    return (
        <Layout
            showHeader={true}
            showFooter={true}
            title="Standard Contractual Clauses | Controller to Processor Transfers" 
            url={`https://www.bracketsninja.com/privacy/scc-c2p`}
            >

            <LongCopy title="Standard Contractual Clauses | Controller to Processor Transfers" >
                <p>
                    <span style={{ fontWeight: 400 }}>
                        These Standard Contractual Clauses are attached to and form part of
                        the Common Ninja Data Processing Addendum available at{' '}
                        <Link href="/privacy/dpa">
                            https://www.bracketsninja.com/privacy/dpa
                        </Link>
                        , or other agreement between Customer and Common Ninja governing the
                        processing of Personal Data solely on behalf of Customer (the
                        &ldquo;
                    </span>
                    <strong>DPA</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;). Unless otherwise defined in this attachment, capitalized
                        terms used in these Standard Contractual Clauses have the meanings
                        given to them in the DPA.
                    </span>
                </p>

                <hgroup className="center">
                    <h4>SECTION I</h4>
                    <h5>
                        <em>Clause 1</em>
                    </h5>
                    <h5>Purpose and scope</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The purpose of these standard contractual clauses is to ensure
                        compliance with the requirements of Regulation (EU) 2016/679 of the
                        European Parliament and of the Council of 27 April 2016 on the
                        protection of natural persons with regard to the processing of
                        personal data and on the free movement of such data (General Data
                        Protection Regulation) for the transfer of personal data to a third
                        country.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>The Parties:</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the natural or legal person(s), public authority/ies, agency/ies or
                        other body/ies (hereinafter &lsquo;entity/ies&rsquo;) transferring
                        the personal data, as listed in Annex I.A (hereinafter each
                        &lsquo;data exporter&rsquo;), and
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the entity/ies in a third country receiving the personal data from
                        the data exporter, directly or indirectly via another entity also
                        Party to these Clauses, as listed in Annex I.A (hereinafter each
                        &lsquo;data importer&rsquo;)
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        have agreed to these standard contractual clauses (hereinafter:
                        &lsquo;Clauses&rsquo;).
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        These Clauses apply with respect to the transfer of personal data as
                        specified in Annex I.B.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Appendix to these Clauses containing the Annexes referred to
                        therein forms an integral part of these Clauses.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 2</em>
                    </h5>
                    <h5>Effect and invariability of the Clauses</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        These Clauses set out appropriate safeguards, including enforceable
                        data subject rights and effective legal remedies, pursuant to
                        Article 46(1) and Article 46(2)(c) of Regulation (EU) 2016/679 and,
                        with respect to data transfers from controllers to processors and/or
                        processors to processors, standard contractual clauses pursuant to
                        Article 28(7) of Regulation (EU) 2016/679, provided they are not
                        modified, except to select the appropriate Module(s) or to add or
                        update information in the Appendix. This does not prevent the
                        Parties from including the standard contractual clauses laid down in
                        these Clauses in a wider contract and/or to add other clauses or
                        additional safeguards, provided that they do not contradict,
                        directly or indirectly, these Clauses or prejudice the fundamental
                        rights or freedoms of data subjects.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        These Clauses are without prejudice to obligations to which the data
                        exporter is subject by virtue of Regulation (EU) 2016/679.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 3</em>
                    </h5>
                    <h5>Third-party beneficiaries</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Data subjects may invoke and enforce these Clauses, as third-party
                        beneficiaries, against the data exporter and/or data importer, with
                        the following exceptions:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Clause 1, Clause 2, Clause 3, Clause 6, Clause 7;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Clause 8.1(b), 8.9(a), (c), (d) and (e);&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Clause 9(a), (c), (d) and (e);&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iv)</span>{' '}
                    <span style={{ fontWeight: 400 }}>Clause 12(a), (d) and (f);</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(v)</span>{' '}
                    <span style={{ fontWeight: 400 }}>Clause 13;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(vi)</span>{' '}
                    <span style={{ fontWeight: 400 }}>Clause 15.1(c), (d) and (e);</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(vii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>Clause 16(e);</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(viii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>Clause 18(a) and (b).</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Paragraph (a) is without prejudice to rights of data subjects under
                        Regulation (EU) 2016/679.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 4</em>
                    </h5>
                    <h5>Interpretation</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Where these Clauses use terms that are defined in Regulation (EU)
                        2016/679, those terms shall have the same meaning as in that
                        Regulation.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        These Clauses shall be read and interpreted in the light of the
                        provisions of Regulation (EU) 2016/679.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        These Clauses shall not be interpreted in a way that conflicts with
                        rights and obligations provided for in Regulation (EU) 2016/679.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 5</em>
                    </h5>
                    <h5>Hierarchy</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        In the event of a contradiction between these Clauses and the
                        provisions of related agreements between the Parties, existing at
                        the time these Clauses are agreed or entered into thereafter, these
                        Clauses shall prevail.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 6</em>
                    </h5>
                    <h5>Description of the transfer(s)</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The details of the transfer(s), and in particular the categories of
                        personal data that are transferred and the purpose(s) for which they
                        are transferred, are specified in Annex I.B.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 7 &ndash; Optional</em>
                    </h5>
                </hgroup>
                <p>Not used.</p>

                <hgroup className="center">
                    <h4>SECTION II &ndash; OBLIGATIONS OF THE PARTIES</h4>
                    <h5>
                        <em>Clause 8</em>
                    </h5>
                    <h5>Data protection safeguards</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The data exporter warrants that it has used reasonable efforts to
                        determine that the data importer is able, through the implementation
                        of appropriate technical and organisational measures, to satisfy its
                        obligations under these Clauses.
                    </span>
                </p>
                <p>
                    <strong>8.1&nbsp;&nbsp;&nbsp;Instructions</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall process the personal data only on documented
                        instructions from the data exporter. The data exporter may give such
                        instructions throughout the duration of the contract.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall immediately inform the data exporter if it
                        is unable to follow those instructions.
                    </span>
                </p>
                <p>
                    <strong>8.2&nbsp;&nbsp;&nbsp;Purpose limitation</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall process the personal data only for the
                        specific purpose(s) of the transfer, as set out in Annex I.B, unless
                        on further instructions from the data exporter.
                    </span>
                </p>
                <p>
                    <strong>8.3&nbsp;&nbsp;&nbsp;Transparency</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        On request, the data exporter shall make a copy of these Clauses,
                        including the Appendix as completed by the Parties, available to the
                        data subject free of charge. To the extent necessary to protect
                        business secrets or other confidential information, including the
                        measures described in Annex II and personal data, the data exporter
                        may redact part of the text of the Appendix to these Clauses prior
                        to sharing a copy, but shall provide a meaningful summary where the
                        data subject would otherwise not be able to understand the its
                        content or exercise his/her rights. On request, the Parties shall
                        provide the data subject with the reasons for the redactions, to the
                        extent possible without revealing the redacted information. This
                        Clause is without prejudice to the obligations of the data exporter
                        under Articles 13 and&nbsp;14 of Regulation (EU) 2016/679.
                    </span>
                </p>
                <p>
                    <strong>8.4&nbsp;&nbsp;&nbsp;Accuracy</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If the data importer becomes aware that the personal data it has
                        received is inaccurate, or has become outdated, it shall inform the
                        data exporter without undue delay. In this case, the data importer
                        shall cooperate with the data exporter to erase or rectify the data.
                    </span>
                </p>
                <p>
                    <strong>
                        8.5&nbsp;&nbsp;&nbsp;Duration of processing and erasure or return of
                        data
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Processing by the data importer shall only take place for the
                        duration specified in Annex I.B. After the end of the provision of
                        the processing services, the data importer shall, at the choice of
                        the data exporter, delete all personal data processed on behalf of
                        the data exporter and certify to the data exporter that it has done
                        so, or return to the data exporter all personal data processed on
                        its behalf and delete existing copies. Until the data is deleted or
                        returned, the data importer shall continue to ensure compliance with
                        these Clauses. In case of local laws applicable to the data importer
                        that prohibit return or deletion of the personal data, the data
                        importer warrants that it will continue to ensure compliance with
                        these Clauses and will only process it to the extent and for as long
                        as required under that local law. This is without prejudice to
                        Clause 14, in particular the requirement for the data importer under
                        Clause 14(e) to notify the data exporter throughout the duration of
                        the contract if it has reason to believe that it is or has become
                        subject to laws or practices not in line with the requirements under
                        Clause 14(a).
                    </span>
                </p>
                <p>
                    <strong>8.6&nbsp;&nbsp;&nbsp;Security of processing</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(a) </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer and, during transmission, also the data exporter
                        shall implement appropriate technical and organisational measures to
                        ensure the security of the data, including protection against a
                        breach of security leading to accidental or unlawful destruction,
                        loss, alteration, unauthorised disclosure or access to that data
                        (hereinafter &lsquo;personal data breach&rsquo;). In assessing the
                        appropriate level of security, the Parties shall take due account of
                        the state of the art, the costs of implementation, the nature,
                        scope, context and purpose(s) of processing and the risks involved
                        in the processing for the data subjects. The Parties shall in
                        particular consider having recourse to encryption or
                        pseudonymisation, including during transmission, where the purpose
                        of processing can be fulfilled in that manner. In case of
                        pseudonymisation, the additional information for attributing the
                        personal data to a specific data subject shall, where possible,
                        remain under the exclusive control of the data exporter. In
                        complying with its obligations under this paragraph, the data
                        importer shall at least implement the technical and organisational
                        measures specified in Annex II. The data importer shall carry out
                        regular checks to ensure that these measures continue to provide an
                        appropriate level of security.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall grant access to the personal data to members
                        of its personnel only to the extent strictly necessary for the
                        implementation, management and monitoring of the contract. It shall
                        ensure that persons authorised to process the personal data have
                        committed themselves to confidentiality or are under an appropriate
                        statutory obligation of confidentiality.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c) </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        In the event of a personal data breach concerning personal data
                        processed by the data importer under these Clauses, the data
                        importer shall take appropriate measures to address the breach,
                        including measures to mitigate its adverse effects. The data
                        importer shall also notify the data exporter without undue delay
                        after having become aware of the breach. Such notification shall
                        contain the details of a contact point where more information can be
                        obtained, a description of the nature of the breach (including,
                        where possible, categories and approximate number of data subjects
                        and personal data records concerned), its likely consequences and
                        the measures taken or proposed to address the breach including,
                        where appropriate, measures to mitigate its possible adverse
                        effects. Where, and in so far as, it is not possible to provide all
                        information at the same time, the initial notification shall contain
                        the information then available and further information shall, as it
                        becomes available, subsequently be provided without undue delay.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d) </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall cooperate with and assist the data exporter
                        to enable the data exporter to comply with its obligations under
                        Regulation (EU) 2016/679, in particular to notify the competent
                        supervisory authority and the affected data subjects, taking into
                        account the nature of processing and the information available to
                        the data importer.
                    </span>
                </p>
                <p>
                    <strong>8.7&nbsp;&nbsp;&nbsp;Sensitive data</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Where the transfer involves personal data revealing racial or ethnic
                        origin, political opinions, religious or philosophical beliefs, or
                        trade union membership, genetic data, or biometric data for the
                        purpose of uniquely identifying a natural person, data concerning
                        health or a person&rsquo;s sex life or sexual orientation, or data
                        relating to criminal convictions and offences (hereinafter
                        &lsquo;sensitive data&rsquo;), the data importer shall apply the
                        specific restrictions and/or additional safeguards described in
                        Annex I.B.
                    </span>
                </p>
                <p>
                    <strong>8.8&nbsp;&nbsp;&nbsp;Onward transfers</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall only disclose the personal data to a third
                        party on documented instructions from the data exporter. In
                        addition, the data may only be disclosed to a third party located
                        outside the European Union&nbsp;(in the same country as the data
                        importer or in another third country, hereinafter &lsquo;onward
                        transfer&rsquo;) if the third party is or agrees to be bound by
                        these Clauses, under the appropriate Module, or if:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the onward transfer is to a country benefitting from an adequacy
                        decision pursuant to Article&nbsp;45 of Regulation (EU) 2016/679
                        that covers the onward transfer;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the third party otherwise ensures appropriate safeguards pursuant to
                        Articles 46 or 47 Regulation of (EU) 2016/679 with respect to the
                        processing in question;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the onward transfer is necessary for the establishment, exercise or
                        defence of legal claims in the context of specific administrative,
                        regulatory or judicial proceedings; or
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iv)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the onward transfer is necessary in order to protect the vital
                        interests of the data subject or of another natural person.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Any onward transfer is subject to compliance by the data importer
                        with all the other safeguards under these Clauses, in particular
                        purpose limitation.
                    </span>
                </p>
                <p>
                    <strong>8.9&nbsp;&nbsp;&nbsp;Documentation and compliance</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall promptly and adequately deal with enquiries
                        from the data exporter that relate to the processing under these
                        Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties shall be able to demonstrate compliance with these
                        Clauses. In particular, the data importer shall keep appropriate
                        documentation on the processing activities carried out on behalf of
                        the data exporter.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall make available to the data exporter all
                        information necessary to demonstrate compliance with the obligations
                        set out in these Clauses and at the data exporter&rsquo;s request,
                        allow for and contribute to audits of the processing activities
                        covered by these Clauses, at reasonable intervals or if there are
                        indications of non-compliance. In deciding on a review or audit, the
                        data exporter may take into account relevant certifications held by
                        the data importer.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data exporter may choose to conduct the audit by itself or
                        mandate an independent auditor. Audits may include inspections at
                        the premises or physical facilities of the data importer and shall,
                        where appropriate, be carried out with reasonable notice.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties shall make the information referred to in paragraphs (b)
                        and (c), including the results of any audits, available to the
                        competent supervisory authority on request.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 9</em>
                    </h5>
                    <h5>Use of sub-processors</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer has the data exporter&rsquo;s general
                        authorisation for the engagement of sub-processor(s) from an agreed
                        list. The data importer shall specifically inform the data exporter
                        in writing of any intended changes to that list through the addition
                        or replacement of sub-processors at least ten (10) business days in
                        advance, thereby giving the data exporter sufficient time to be able
                        to object to such changes prior to the engagement of the
                        sub-processor(s). The data importer shall provide the data exporter
                        with the information necessary to enable the data exporter to
                        exercise its right to object.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b) </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Where the data importer engages a sub-processor to carry out
                        specific processing activities (on behalf of the data exporter), it
                        shall do so by way of a written contract that provides for, in
                        substance, the same data protection obligations as those binding the
                        data importer under these Clauses, including in terms of third-party
                        beneficiary rights for data subjects. The Parties agree that, by
                        complying with this Clause, the data importer fulfils its
                        obligations under Clause 8.8. The data importer shall ensure that
                        the sub-processor complies with the obligations to which the data
                        importer is subject pursuant to these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall provide, at the data exporter&rsquo;s
                        request, a copy of such a sub-processor agreement and any subsequent
                        amendments to the data exporter. To the extent necessary to protect
                        business secrets or other confidential information, including
                        personal data, the data importer may redact the text of the
                        agreement prior to sharing a copy.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall remain fully responsible to the data
                        exporter for the performance of the sub-processor&rsquo;s
                        obligations under its contract with the data importer. The data
                        importer shall notify the data exporter of any failure by the
                        sub-processor to fulfil its obligations under that contract.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall agree a third-party beneficiary clause with
                        the sub-processor whereby &ndash; in the event the data importer has
                        factually disappeared, ceased to exist in law or has become
                        insolvent &ndash; the data exporter shall have the right to
                        terminate the sub-processor contract and to instruct the
                        sub-processor to erase or return the personal data.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 10</em>
                    </h5>
                    <h5>Data subject rights</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall promptly notify the data exporter of any
                        request it has received from a data subject. It shall not respond to
                        that request itself unless it has been authorised to do so by the
                        data exporter.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall assist the data exporter in fulfilling its
                        obligations to respond to data subjects&rsquo; requests for the
                        exercise of their rights under Regulation (EU) 2016/679. In this
                        regard, the Parties shall set out in Annex II the appropriate
                        technical and organisational measures, taking into account the
                        nature of the processing, by which the assistance shall be provided,
                        as well as the scope and the extent of the assistance required.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        In fulfilling its obligations under paragraphs (a) and (b), the data
                        importer shall comply with the instructions from the data exporter.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 11</em>
                    </h5>
                    <h5>Redress</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall inform data subjects in a transparent and
                        easily accessible format, through individual notice or on its
                        website, of a contact point authorised to handle complaints. It
                        shall deal promptly with any complaints it receives from a data
                        subject.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        In case of a dispute between a data subject and one of the Parties
                        as regards compliance with these Clauses, that Party shall use its
                        best efforts to resolve the issue amicably in a timely fashion. The
                        Parties shall keep each other informed about such disputes and,
                        where appropriate, cooperate in resolving them.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Where the data subject invokes a third-party beneficiary right
                        pursuant to Clause 3, the data importer shall accept the decision of
                        the data subject to:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        lodge a complaint with the supervisory authority in the Member State
                        of his/her habitual residence or place of work, or the competent
                        supervisory authority pursuant to Clause 13;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        refer the dispute to the competent courts within the meaning of
                        Clause 18.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties accept that the data subject may be represented by a
                        not-for-profit body, organisation or association under the
                        conditions set out in Article 80(1) of Regulation (EU) 2016/679.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall abide by a decision that is binding under
                        the applicable EU or Member State law.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(f)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees that the choice made by the data subject
                        will not prejudice his/her substantive and procedural rights to seek
                        remedies in accordance with applicable laws.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 12</em>
                    </h5>
                    <h5>Liability</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Each Party shall be liable to the other Party/ies for any damages it
                        causes the other Party/ies by any breach of these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall be liable to the data subject, and the data
                        subject shall be entitled to receive compensation, for any material
                        or non-material damages the data importer or its sub-processor
                        causes the data subject by breaching the third-party beneficiary
                        rights under these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Notwithstanding paragraph (b), the data exporter shall be liable to
                        the data subject, and the data subject shall be entitled to receive
                        compensation, for any material or non-material damages the data
                        exporter or the data importer (or its sub-processor) causes the data
                        subject by breaching the third-party beneficiary rights under these
                        Clauses. This is without prejudice to the liability of the data
                        exporter and, where the data exporter is a processor acting on
                        behalf of a controller, to the liability of the controller under
                        Regulation (EU) 2016/679 or Regulation (EU) 2018/1725, as
                        applicable.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree that if the data exporter is held liable under
                        paragraph (c) for damages caused by the data importer (or its
                        sub-processor), it shall be entitled to claim back from the data
                        importer that part of the compensation corresponding to the data
                        importer&rsquo;s responsibility for the damage.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Where more than one Party is responsible for any damage caused to
                        the data subject as a result of a breach of these Clauses, all
                        responsible Parties shall be jointly and severally liable and the
                        data subject is entitled to bring an action in court against any of
                        these Parties.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(f)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree that if one Party is held liable under paragraph
                        (e), it shall be entitled to claim back from the other Party/ies
                        that part of the compensation corresponding to its/their
                        responsibility for the damage.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(g)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer may not invoke the conduct of a sub-processor to
                        avoid its own liability.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 13</em>
                    </h5>
                    <h5>Supervision</h5>
                </hgroup>
                <p style={{ fontWeight: 400 }}>
                    <span style={{ fontWeight: 400 }}>
                        Where the data exporter is established in an EU Member State: The
                        supervisory authority with responsibility for ensuring compliance by
                        the data exporter with Regulation (EU) 2016/679 as regards the data
                        transfer, as indicated in Annex I.C, shall act as competent
                        supervisory authority.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Where the data exporter is not established in an EU Member State,
                        but falls within the territorial scope of application of Regulation
                        (EU) 2016/679 in accordance with its Article&nbsp;3(2) and has
                        appointed a representative pursuant to Article&nbsp;27(1) of
                        Regulation (EU) 2016/679: The supervisory authority of the Member
                        State in which the representative within the meaning of
                        Article&nbsp;27(1) of Regulation (EU) 2016/679 is established, as
                        indicated in Annex I.C, shall act as competent supervisory
                        authority.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Where the data exporter is not established in an EU Member State,
                        but falls within the territorial scope of application of Regulation
                        (EU) 2016/679 in accordance with its Article&nbsp;3(2) without
                        however having to appoint a representative pursuant to
                        Article&nbsp;27(2) of Regulation (EU) 2016/679: The supervisory
                        authority of one of the Member States in which the data subjects
                        whose personal data is transferred under these Clauses in relation
                        to the offering of goods or services to them, or whose behaviour is
                        monitored, are located, as indicated in Annex I.C, shall act as
                        competent supervisory authority.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to submit itself to the jurisdiction of and
                        cooperate with the competent supervisory authority in any procedures
                        aimed at ensuring compliance with these Clauses. In particular, the
                        data importer agrees to respond to enquiries, submit to audits and
                        comply with the measures adopted by the supervisory authority,
                        including remedial and compensatory measures. It shall provide the
                        supervisory authority with written confirmation that the necessary
                        actions have been taken.
                    </span>
                </p>
                <hgroup className="center">
                    <h4>
                        SECTION III &ndash; LOCAL LAWS AND OBLIGATIONS IN CASE OF ACCESS BY
                        PUBLIC AUTHORITIES
                    </h4>
                    <h5>
                        <em>Clause 14</em>
                    </h5>
                    <h5>
                        Local laws and practices affecting compliance with the Clauses
                    </h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>&nbsp;(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties warrant that they have no reason to believe that the
                        laws and practices in the third country of destination applicable to
                        the processing of the personal data by the data importer, including
                        any requirements to disclose personal data or measures authorising
                        access by public authorities, prevent the data importer from
                        fulfilling its obligations under these Clauses. This is based on the
                        understanding that laws and practices that respect the essence of
                        the fundamental rights and freedoms and do not exceed what is
                        necessary and proportionate in a democratic society to safeguard one
                        of the objectives listed in Article 23(1) of Regulation (EU)
                        2016/679, are not in contradiction with these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties declare that in providing the warranty in paragraph (a),
                        they have taken due account in particular of the following elements:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the specific circumstances of the transfer, including the length of
                        the processing chain, the number of actors involved and the
                        transmission channels used; intended onward transfers; the type of
                        recipient; the purpose of processing; the categories and format of
                        the transferred personal data; the economic sector in which the
                        transfer occurs; the storage location of the data transferred;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the laws and practices of the third country of destination&ndash;
                        including those requiring the disclosure of data to public
                        authorities or authorising access by such authorities &ndash;
                        relevant in light of the specific circumstances of the transfer, and
                        the applicable limitations and safeguards;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        any relevant contractual, technical or organisational safeguards put
                        in place to supplement the safeguards under these Clauses, including
                        measures applied during transmission and to the processing of the
                        personal data in the country of destination.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer warrants that, in carrying out the assessment
                        under paragraph (b), it has made its best efforts to provide the
                        data exporter with relevant information and agrees that it will
                        continue to cooperate with the data exporter in ensuring compliance
                        with these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree to document the assessment under paragraph (b) and
                        make it available to the competent supervisory authority on request.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to notify the data exporter promptly if,
                        after having agreed to these Clauses and for the duration of the
                        contract, it has reason to believe that it is or has become subject
                        to laws or practices not in line with the requirements under
                        paragraph (a), including following a change in the laws of the third
                        country or a measure (such as a disclosure request) indicating an
                        application of such laws in practice that is not in line with the
                        requirements in paragraph (a).&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(f)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Following a notification pursuant to paragraph (e), or if the data
                        exporter otherwise has reason to believe that the data importer can
                        no longer fulfil its obligations under these Clauses, the data
                        exporter shall promptly identify appropriate measures (e.g.
                        technical or organisational measures to ensure security and
                        confidentiality) to be adopted by the data exporter and/or data
                        importer to address the situation. The data exporter shall suspend
                        the data transfer if it considers that no appropriate safeguards for
                        such transfer can be ensured, or if instructed by the competent
                        supervisory authority to do so. In this case, the data exporter
                        shall be entitled to terminate the contract, insofar as it concerns
                        the processing of personal data under these Clauses. If the contract
                        involves more than two Parties, the data exporter may exercise this
                        right to termination only with respect to the relevant Party, unless
                        the Parties have agreed otherwise. Where the contract is terminated
                        pursuant to this Clause, Clause 16(d) and (e) shall apply.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 15</em>
                    </h5>
                    <h5>
                        Obligations of the data importer in case of access by public
                        authorities
                    </h5>
                </hgroup>
                <p>
                    <strong>15.1 &nbsp; </strong> <strong>Notification</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to notify the data exporter and, where
                        possible, the data subject promptly (if necessary with the help of
                        the data exporter) if it:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        receives a legally binding request from a public authority,
                        including judicial authorities, under the laws of the country of
                        destination for the disclosure of personal data transferred pursuant
                        to these Clauses; such notification shall include information about
                        the personal data requested, the requesting authority, the legal
                        basis for the request and the response provided; or
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        becomes aware of any direct access by public authorities to personal
                        data transferred pursuant to these Clauses in accordance with the
                        laws of the country of destination; such notification shall include
                        all information available to the importer.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>&nbsp;(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        If the data importer is prohibited from notifying the data exporter
                        and/or the data subject under the laws of the country of
                        destination, the data importer agrees to use its best efforts to
                        obtain a waiver of the prohibition, with a view to communicating as
                        much information as possible, as soon as possible. The data importer
                        agrees to document its best efforts in order to be able to
                        demonstrate them on request of the data exporter.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Where permissible under the laws of the country of destination, the
                        data importer agrees to provide the data exporter, at regular
                        intervals for the duration of the contract, with as much relevant
                        information as possible on the requests received (in particular,
                        number of requests, type of data requested, requesting
                        authority/ies, whether requests have been challenged and the outcome
                        of such challenges, etc.).&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to preserve the information pursuant to
                        paragraphs (a) to (c) for the duration of the contract and make it
                        available to the competent supervisory authority on request.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Paragraphs (a) to (c) are without prejudice to the obligation of the
                        data importer pursuant to Clause 14(e) and Clause 16 to inform the
                        data exporter promptly where it is unable to comply with these
                        Clauses.
                    </span>
                </p>
                <p>
                    <strong>15.2 &nbsp; </strong>{' '}
                    <strong>Review of legality and data minimisation</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to review the legality of the request for
                        disclosure, in particular whether it remains within the powers
                        granted to the requesting public authority, and to challenge the
                        request if, after careful assessment, it concludes that there are
                        reasonable grounds to consider that the request is unlawful under
                        the laws of the country of destination, applicable obligations under
                        international law and principles of international comity. The data
                        importer shall, under the same conditions, pursue possibilities of
                        appeal. When challenging a request, the data importer shall seek
                        interim measures with a view to suspending the effects of the
                        request until the competent judicial authority has decided on its
                        merits. It shall not disclose the personal data requested until
                        required to do so under the applicable procedural rules. These
                        requirements are without prejudice to the obligations of the data
                        importer under Clause 14(e).
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to document its legal assessment and any
                        challenge to the request for disclosure and, to the extent
                        permissible under the laws of the country of destination, make the
                        documentation available to the data exporter. It shall also make it
                        available to the competent supervisory authority on request.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer agrees to provide the minimum amount of
                        information permissible when responding to a request for disclosure,
                        based on a reasonable interpretation of the request.
                    </span>
                </p>
                <hgroup className="center">
                    <h4>SECTION IV &ndash; FINAL PROVISIONS</h4>
                    <h5>
                        <em>Clause 16</em>
                    </h5>
                    <h5>Non-compliance with the Clauses and termination</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data importer shall promptly inform the data exporter if it is
                        unable to comply with these Clauses, for whatever reason.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        In the event that the data importer is in breach of these Clauses or
                        unable to comply with these Clauses, the data exporter shall suspend
                        the transfer of personal data to the data importer until compliance
                        is again ensured or the contract is terminated. This is without
                        prejudice to Clause 14(f).
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The data exporter shall be entitled to terminate the contract,
                        insofar as it concerns the processing of personal data under these
                        Clauses, where:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(i)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the data exporter has suspended the transfer of personal data to the
                        data importer pursuant to paragraph (b) and compliance with these
                        Clauses is not restored within a reasonable time and in any event
                        within one month of suspension;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(ii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the data importer is in substantial or persistent breach of these
                        Clauses; or
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(iii)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        the data importer fails to comply with a binding decision of a
                        competent court or supervisory authority regarding its obligations
                        under these Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        In these cases, it shall inform the competent supervisory authority
                        of such non-compliance. Where the contract involves more than two
                        Parties, the data exporter may exercise this right to termination
                        only with respect to the relevant Party, unless the Parties have
                        agreed otherwise.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Personal data that has been transferred prior to the termination of
                        the contract pursuant to paragraph (c) shall at the choice of the
                        data exporter immediately be returned to the data exporter or
                        deleted in its entirety. The same shall apply to any copies of the
                        data. The data importer shall certify the deletion of the data to
                        the data exporter. Until the data is deleted or returned, the data
                        importer shall continue to ensure compliance with these Clauses. In
                        case of local laws applicable to the data importer that prohibit the
                        return or deletion of the transferred personal data, the data
                        importer warrants that it will continue to ensure compliance with
                        these Clauses and will only process the data to the extent and for
                        as long as required under that local law.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(e)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Either Party may revoke its agreement to be bound by these Clauses
                        where (i) the European Commission adopts a decision pursuant to
                        Article 45(3) of Regulation (EU) 2016/679 that covers the transfer
                        of personal data to which these Clauses apply; or (ii) Regulation
                        (EU) 2016/679 becomes part of the legal framework of the country to
                        which the personal data is transferred. This is without prejudice to
                        other obligations applying to the processing in question under
                        Regulation (EU) 2016/679.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 17</em>
                    </h5>
                    <h5>Governing law</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        These Clauses shall be governed by the law of one of the EU Member
                        States, provided such law allows for third-party beneficiary rights.
                        The Parties agree that this shall be the law of the Republic of
                        Ireland.
                    </span>
                </p>
                <hgroup className="center">
                    <h5>
                        <em>Clause 18</em>
                    </h5>
                    <h5>Choice of forum and jurisdiction</h5>
                </hgroup>
                <p>
                    <span style={{ fontWeight: 400 }}>(a)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        Any dispute arising from these Clauses shall be resolved by the
                        courts of an EU Member State.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(b)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree that those shall be the courts of{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>the Republic of Ireland.</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(c)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        A data subject may also bring legal proceedings against the data
                        exporter and/or data importer before the courts of the Member State
                        in which he/she has his/her habitual residence.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>(d)</span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree to submit themselves to the jurisdiction of such
                        courts.
                    </span>
                    <span style={{ fontWeight: 400 }}>
                        <br />
                    </span>
                </p>

                <h3 className="center">ANNEX I</h3>
                <h4>A. LIST OF PARTIES</h4>
                <p>
                    <strong>Data exporter(s):</strong>
                    <span style={{ fontWeight: 400 }}>&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Name: The entity identified as &ldquo;Customer&rdquo; in the DPA or
                        the Agreement or through the Customer&rsquo;s account in the
                        Services.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Address: The address for Customer as specified in the DPA or the
                        Agreement or through the Customer&rsquo;s account in the
                        Services.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Contact person&rsquo;s name, position and contact details: The
                        contact details associated with Customer, as specified in the DPA or
                        the Agreement or through the Customer&rsquo;s account in the
                        Services.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Activities relevant to the data transferred under these Clauses: The
                        activities specified in Section 2.3 and Schedule 1 of the DPA.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Signature and date: By entering into the Agreement and DPA, and
                        using the Services for EEA Transfers, the data exporter is deemed to
                        have signed these Standard Contractual Clauses and their respective
                        Annexes.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Role (controller/processor): Controller.
                    </span>
                </p>
                <p>
                    <strong>Data importer(s):</strong>
                    <span style={{ fontWeight: 400 }}>&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Name: Common Ninja as identified in the DPA.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Address: Mefi 5, Netanya, Israel.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Contact person&rsquo;s name, position and contact details: Daniel
                        Stenrlicht, CEO, daniel@commoninja.com.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Activities relevant to the data transferred under these Clauses:
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The activities specified in Section 2.3 and Schedule 1 of the DPA.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Signature and date: By entering into the Agreement and DPA, and
                        engaging in EEA Transfers as the data importer on behalf of the data
                        exporter, the data importer is deemed to have signed these Standard
                        Contractual Clauses and their respective Annexes.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Role (controller/processor): Processor.
                    </span>
                </p>
                <h4>B. DESCRIPTION OF TRANSFER</h4>
                <p>
                    <strong>
                        <em>
                            Categories of data subjects whose personal data is transferred
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The categories of data subjects are described in Schedule 1 (Details
                        of Processing) of the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>Categories of personal data transferred</em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The categories of personal data are described in Schedule 1 (Details
                        of Processing) of the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>
                            Sensitive data transferred (if applicable) and applied
                            restrictions or safeguards that fully take into consideration the
                            nature of the data and the risks involved, such as for instance
                            strict purpose limitation, access restrictions (including access
                            only for staff having followed specialised training), keeping a
                            record of access to the data, restrictions for onward transfers or
                            additional security measures.
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The Parties do not intend for Sensitive Data to be transferred,
                        except in accordance with Section 2.5 of the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>
                            The frequency of the transfer (e.g. whether the data is
                            transferred on a one-off or continuous basis).
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Personal Data is transferred on a continuous basis in accordance
                        with the Customer&rsquo;s use of the Services and submission of
                        Personal Data thereto.&nbsp;
                    </span>
                </p>
                <p>
                    <strong>
                        <em>Nature of the processing</em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The nature of the processing is described in Schedule 1 (Details of
                        Processing) of the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>Purpose(s) of the data transfer and further processing</em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The purpose of the processing is described in Schedule 1 (Details of
                        Processing) of the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>
                            The period for which the personal data will be retained, or, if
                            that is not possible, the criteria used to determine that period
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The period for which Personal Data will be retained is for the
                        duration of the Agreement, unless agreed otherwise in the Agreement
                        and/or the DPA.
                    </span>
                </p>
                <p>
                    <strong>
                        <em>
                            For transfers to (sub-) processors, also specify subject matter,
                            nature and duration of the processing
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        In relation to transfers to Sub-processors, the subject matter, and
                        nature of the processing is set forth at&nbsp;the link detailed in
                        Section 5.2 of the DPA. The duration of the processing by
                        Sub-processors is the duration of the Agreement, unless agreed
                        otherwise in the Agreement and/or the DPA.
                    </span>
                </p>
                <h4>C. COMPETENT SUPERVISORY AUTHORITY</h4>
                <p>
                    <strong>
                        <em>
                            Identify the competent supervisory authority/ies in accordance
                            with Clause 13
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The data exporter&rsquo;s competent supervisory authority will be
                        determined in accordance with the GDPR.
                    </span>
                </p>

                <h3 className="center">ANNEX II</h3>
                <p className="center">
                    <strong>
                        TECHNICAL AND ORGANISATIONAL MEASURES INCLUDING TECHNICAL AND
                        ORGANISATIONAL MEASURES TO ENSURE THE SECURITY OF THE DATA
                    </strong>
                </p>
                <p>
                    <strong>
                        <em>
                            Description of the technical and organisational measures
                            implemented by the data importer(s) (including any relevant
                            certifications) to ensure an appropriate level of security, taking
                            into account the nature, scope, context and purpose of the
                            processing, and the risks for the rights and freedoms of natural
                            persons&nbsp;
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The technical and organizational measures (including the
                        certifications held by the data importer) as well as the scope and
                        the extent of the assistance required to respond to data
                        subjects&rsquo; requests, are described in the DPA and Security
                        Documentation.&nbsp;
                    </span>
                </p>
                <p>
                    <strong>
                        <em>
                            For transfers to (sub-) processors, also describe the specific
                            technical and organisational measures to be taken by the (sub-)
                            processor to be able to provide assistance to the controller and,
                            for transfers from a processor to a sub-processor, to the data
                            exporter.&nbsp;
                        </em>
                    </strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The technical and organisational measures that the data importer
                        will impose on sub-processors are described in the DPA.
                    </span>
                </p>
                <h3 className="center">ANNEX III</h3>
                <p className="center">
                    <strong>UK CROSS-BORDER DATA TRANSFERS</strong>
                </p>
                <p>
                    <strong>Table 1: The Parties:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        as stipulated in Annex I of the Standard Contractual Clauses.
                    </span>
                </p>
                <p>
                    <strong>Table 2: Selected SCCs, Modules and Selected Clauses:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        The Standard Contractual Clauses; Module 2: Controller to Processor;
                        Clause 7 (Docking Clause): No; Clause 11 (Option): No; Clause 9a
                        (Prior Authorisation or General Authorisation): General
                        Authorisation; Clause 9a (Time Period): At Least ten (10) days in
                        advance.
                    </span>
                </p>
                <p>
                    <strong>Table 3: Appendix Information: </strong>
                    <span style={{ fontWeight: 400 }}>
                        means the information which must be provided for the selected
                        modules as set out in the Appendix of the Standard Contractual
                        Clauses (other than the Parties), and which for this Annex III is
                        set out in Annex I of the Standard Contractual Clauses.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>Entering into this Annex III</span>
                    <span style={{ fontWeight: 400 }}>:</span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Each Party agrees to be bound by the terms and conditions set out
                            in this Annex III, in exchange for the other Party also agreeing
                            to be bound by this Annex III.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Although Annex 1A and Clause 7 of the Standard Contractual Clauses
                            require signatures by the Parties, for the purpose of making UK
                            Transfers, the Parties may enter into this Annex III in any way
                            that makes them legally binding on the Parties and allows data
                            subjects to enforce their rights as set out in this Annex III.
                            Entering into this Annex III will have the same effect as signing
                            the Standard Contractual Clauses and any part of the Standard
                            Contractual Clauses.
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Interpretation of this Annex III
                    </span>
                    <span style={{ fontWeight: 400 }}>:</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        3. Where this Annex III uses terms that are defined in the Standard
                        Contractual Clauses, those terms shall have the same meaning as in
                        the Standard Contractual Clauses. In addition, the following terms
                        have the following meanings:
                    </span>
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>Addendum EU SCCs</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        The version(s) of the Standard Contractual Clauses which
                                        this Annex III is appended to, as set out in Table 2,
                                        including the Appendix Information.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>Appendix Information</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        As set out in Table 3.&nbsp;&nbsp;&nbsp;
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        Appropriate Safeguards&nbsp;
                                    </span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        The standard of protection over the personal data and of
                                        data subjects&rsquo; rights, which is required by UK Data
                                        Protection Laws when the Parties are making a UK Transfer
                                        relying on standard data protection clauses under Article
                                        46(2)(d) UK GDPR.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        Standard Contractual Clauses
                                    </span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>As defined in the DPA</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>ICO</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        The information commissioner.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>Annex III</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        This Annex III which is made up of this Annex III
                                        incorporating the Addendum EU SCCs.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>UK Addendum</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        The template Addendum issued by the ICO and laid before
                                        Parliament in accordance with s119A of the Data Protection
                                        Act 2018 on 2 February 2022, as it is revised under Section
                                        18 of this Annex III.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        UK Data Protection Laws
                                    </span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        All laws relating to data protection, the processing of
                                        personal data, privacy and/or electronic communications in
                                        force from time to time in the UK, including the UK GDPR and
                                        the Data Protection Act 2018.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>UK GDPR</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        As defined in Section 3 of the Data Protection Act 2018.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>UK</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        The United Kingdom of Great Britain and Northern Ireland.
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>UK Transfer</span>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span style={{ fontWeight: 400 }}>
                                        A transfer which is covered by Chapter V of the UK GDPR.
                                    </span>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            This Annex III must always be interpreted in a manner that is
                            consistent with UK Data Protection Laws and so that it fulfils the
                            Parties&rsquo; obligation to provide the Appropriate
                            Safeguards.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If the provisions included in the Addendum EU SCCs amend the
                            Standard Contractual Clauses in any way which is not permitted
                            under the Standard Contractual Clauses or this Annex III, such
                            amendment(s) will not be incorporated by this Annex III and the
                            equivalent provision of the Standard Contractual Clauses will take
                            their place.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If there is any inconsistency or conflict between UK Data
                            Protection Laws and this Annex III, UK Data Protection Laws apply.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If the meaning of this Annex III is unclear or there is more than
                            one meaning, the meaning that most closely aligns with UK Data
                            Protection Laws applies.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Any references to legislation (or specific provisions of
                            legislation) means that legislation (or specific provision) as it
                            may change over time. This includes where that legislation (or
                            specific provision) has been consolidated, re-enacted, and/or
                            replaced after this DPA has been entered into.
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>Hierarchy</span>
                    <span style={{ fontWeight: 400 }}>:</span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Although Clause 5 of Standard Contractual Clauses sets out that
                            the Standard Contractual Clauses prevail over all related
                            agreements between the Parties, the Parties agree that, for a UK
                            Transfer, the hierarchy in Section{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                        <span style={{ fontWeight: 400 }}>10 below will prevail.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Where there is any inconsistency or conflict between this Annex
                            III and the Addendum EU SCCs (as applicable), this Annex III
                            overrides the Addendum EU SCCs, except where (and in so far as)
                            the inconsistent or conflicting terms of the Addendum EU SCCs
                            provides greater protection for data subjects, in which case those
                            terms will override the provisions of this Annex III.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Where this Annex III incorporates Addendum EU SCCs which have been
                            entered into to protect transfers subject to the General Data
                            Protection Regulation (EU) 2016/679 then the Parties acknowledge
                            that nothing in this Annex III impacts those Addendum EU SCCs.
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Incorporation and changes to the Standard Contractual Clauses
                    </span>
                    <span style={{ fontWeight: 400 }}>:</span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            This Annex III incorporates the Addendum EU SCCs which are amended
                            to the extent necessary so that:&nbsp;
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            together they operate for data transfers made by the data exporter
                            to the data importer, to the extent that UK Data Protection Laws
                            apply to the data exporter&rsquo;s processing when making that
                            data transfer, and they provide Appropriate Safeguards for those
                            data transfers;&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Sections 9 to 11 override Clause 5 (Hierarchy) of the Standard
                            Contractual Clauses; and
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            this Annex III (including the Addendum EU SCCs incorporated into
                            it) is (1) governed by the laws of England and Wales and (2) any
                            dispute arising from it is resolved by the courts of England and
                            Wales, in each case unless the laws and/or courts of Scotland or
                            Northern Ireland have been expressly selected by the Parties.
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Unless the Parties have agreed on alternative amendments which
                            meet the requirements of Section 12 above, the provisions of
                            Section{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                        <span style={{ fontWeight: 400 }}>15 below will apply.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            No amendments to the Standard Contractual Clauses other than to
                            meet the requirements of Section{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                        <span style={{ fontWeight: 400 }}>12 above may be made.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The following amendments to the Addendum EU SCCs (for the purpose
                            of Section 12 above) are made:&nbsp;
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to the &ldquo;Clauses&rdquo; mean this Annex III,
                            incorporating the Addendum EU SCCs;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            In Clause 2, delete the words: &ldquo;and, with respect to data
                            transfers from controllers to processors and/or processors to
                            processors, standard contractual clauses pursuant to Article 28(7)
                            of Regulation (EU) 2016/679&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Clause 6 (Description of the transfer(s)) is replaced with:
                            &ldquo;The details of the transfers(s) and in particular the
                            categories of personal data that are transferred and the
                            purpose(s) for which they are transferred) are those specified in
                            Annex I.B where UK Data Protection Laws apply to the data
                            exporter&rsquo;s processing when making that transfer.&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To the extent applicable, Clause 8.7(i) of Module One is replaced
                            with: &ldquo;it is to a country benefitting from adequacy
                            regulations pursuant to Section 17A of the UK GDPR that covers the
                            onward transfer&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Clause 8.8(i) of Modules Two and Three is replaced with:
                            &ldquo;the onward transfer is to a country benefitting from
                            adequacy regulations pursuant to Section 17A of the UK GDPR that
                            covers the onward transfer;&rdquo;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to &ldquo;Regulation (EU) 2016/679&rdquo;,
                            &ldquo;Regulation (EU) 2016/679 of the European Parliament and of
                            the Council of 27 April 2016 on the protection of natural persons
                            with regard to the processing of personal data and on the free
                            movement of such data (General Data Protection Regulation)&rdquo;
                            and &ldquo;that Regulation&rdquo; are all replaced by &ldquo;UK
                            Data Protection Laws&rdquo;. References to specific Article(s) of
                            &ldquo;Regulation (EU) 2016/679&rdquo; are replaced with the
                            equivalent Article or Section of UK Data Protection Laws;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to Regulation (EU) 2018/1725 are removed;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to the &ldquo;European Union&rdquo;,
                            &ldquo;Union&rdquo;, &ldquo;EU&rdquo;, &ldquo;EU Member
                            State&rdquo;, &ldquo;Member State&rdquo; and &ldquo;EU or Member
                            State&rdquo; are all replaced with the &ldquo;UK&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To the extent applicable, the reference to &ldquo;Clause
                            12(c)(i)&rdquo; at Clause 10(b)(i) of Module One, is replaced with
                            &ldquo;Clause 11(c)(i)&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Clause 13(a) and Part C of Annex I are not used;&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The &ldquo;competent supervisory authority&rdquo; and
                            &ldquo;supervisory authority&rdquo; are both replaced with the
                            &ldquo;Information Commissioner&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            In Clause 16(e), subsection (i) is replaced with: &ldquo;the
                            Secretary of State makes regulations pursuant to Section 17A of
                            the Data Protection Act 2018 that cover the transfer of personal
                            data to which these clauses apply;&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Clause 17 is replaced with: &ldquo;These Clauses are governed by
                            the laws of England and Wales.&rdquo;;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Clause 18 is replaced with: &ldquo;Any dispute arising from these
                            Clauses shall be resolved by the courts of England and Wales. A
                            data subject may also bring legal proceedings against the data
                            exporter and/or data importer before the courts of any country in
                            the UK. The Parties agree to submit themselves to the jurisdiction
                            of such courts.&rdquo;; and
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The footnotes to the Standard Contractual Clauses do not form part
                            of this Annex III, except for footnotes 8, 9, 10 and 11.
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>Amendments to this Annex III</span>
                    <span style={{ fontWeight: 400 }}>:</span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The Parties may agree to change Clause 17 and/or 18 of this Annex
                            III to refer to the laws and/or courts of Scotland or Northern
                            Ireland.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If the Parties wish to change the format of the information
                            included in Tables 1, 2 or 3 of this Annex III, they may do so by
                            agreeing to the change in writing, provided that the change does
                            not reduce the Appropriate Safeguards.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            From time to time, the ICO may issue a revised UK Addendum which:
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            makes reasonable and proportionate changes to the UK Addendum,
                            including correcting errors in the UK Addendum; and/or
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            reflects changes to UK Data Protection Laws;
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The revised UK Addendum will specify the start date from which the
                        changes to the UK Addendum are effective and whether the Parties
                        need to review this Annex III including the Appendix Information.
                        This Annex III is automatically amended as set out in the revised UK
                        Addendum from the start date specified.
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If the ICO issues a revised UK Addendum under Section{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                        <span style={{ fontWeight: 400 }}>
                            18, if any Party, will as a direct result of the changes in the UK
                            Addendum have a substantial, disproportionate and demonstrable
                            increase in:&nbsp;
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            its direct costs of performing its obligations under this Annex
                            III; and/or&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            its risk under this Annex III,&nbsp;
                        </span>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        and in either case, it has first taken reasonable steps to reduce
                        those costs or risks so that it is not substantial and
                        disproportionate, then that Party may end this Annex III at the end
                        of a reasonable notice period, by providing written notice for that
                        period to the other Party before the start date of the revised UK
                        Addendum.
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The Parties do not need the consent of any third party to make
                            changes to this Annex III, but any changes must be made in
                            accordance with its terms.
                        </span>
                    </li>
                </ol>

                <h3 className="center">ANNEX IIII</h3>
                <p className="center">
                    <strong>SWISS CROSS-BORDER DATA TRANSFERS</strong>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        The Parties agree that the Standard Contractual Clauses shall be
                        adjusted as set out below where the FADP applies to Swiss Transfers:
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to the Standard Contractual Clauses mean the Standard
                            Contractual Clauses as amended by this Annex IV;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The Swiss Federal Data Protection and Information Commissioner
                            shall be the sole Supervisory Authority for Swiss Transfers
                            exclusively subject to the FADP;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The terms &ldquo;General Data Protection Regulation&rdquo; or
                            &ldquo;Regulation (EU) 2016/679&rdquo; as utilized in the Standard
                            Contractual Clauses shall be interpreted to include the FADP with
                            respect to Swiss Transfers;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to Regulation (EU) 2018/1725 are removed;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Swiss Transfers subject to both the FADP and the GDPR, shall be
                            dealt with by the EU Supervisory Authority named in Annex I.C of
                            the Standard Contractual Clauses;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            References to the &ldquo;Union&rdquo;, &ldquo;EU&rdquo; and
                            &ldquo;EU Member State&rdquo; shall not be interpreted in such a
                            way as to exclude Data Subjects in Switzerland from the
                            possibility of exercising their rights in their place of habitual
                            residence (Switzerland) in accordance with Clause 18(c) of the
                            Standard Contractual Clauses;&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Where Swiss Transfers are exclusively subject to the FADP, all
                            references to the GDPR in the Standard Contractual Clauses are to
                            be understood to be references to the FADP;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Where Swiss Transfers are subject to both the FADP and the GDPR,
                            all references to the GDPR in the Standard Contractual Clauses are
                            to be understood to be references to the FADP insofar as the Swiss
                            Transfers are subject to the FADP;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The Standard Contractual Clauses as amended by this Annex IV also
                            protect the Personal Data of legal entities until the entry into
                            force of the Revised FADP.
                        </span>
                    </li>
                </ol>
                <h3 className="center">ANNEX V</h3>
                <p className="center">
                    <strong>ADDITIONAL SAFEGUARDS</strong>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            In the event of an EEA Transfer, Swiss Transfer or a UK Transfer,
                            the Parties agree to supplement these with the following
                            safeguards and representations, where appropriate:&nbsp;
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The data importer shall have in place and maintain in accordance
                            with good industry practice measures to protect the Personal Data
                            from interception (including in transit from the data exporter to
                            the data importer and between different systems and services).
                            This includes having in place and maintaining network protection
                            intended to deny attackers the ability to intercept data and
                            encryption of Personal Data whilst in transit and at rest intended
                            to deny attackers the ability to read data.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The data importer will make commercially reasonable efforts to
                            resist, subject to applicable laws, any request for bulk
                            surveillance relating to the Personal Data protected under GDPR or
                            the UK GDPR, including under section 702 of the United States
                            Foreign Intelligence Surveillance Act (&ldquo;
                        </span>
                        <strong>FISA</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;);&nbsp;</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            If the data importer becomes aware that any government authority
                            (including law enforcement) wishes to obtain access to or a copy
                            of some or all of the Personal Data, whether on a voluntary or a
                            mandatory basis, then unless legally prohibited or under a
                            mandatory legal compulsion that requires otherwise:
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The data importer shall inform the relevant government authority
                            that the data importer is a processor of the Personal Data and
                            that the data exporter has not authorized the data importer to
                            disclose the Personal Data to the government authority, and inform
                            the relevant government authority that any and all requests or
                            demands for access to the Personal Data should therefore be
                            notified to or served upon the data exporter in writing;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The data importer will use commercially reasonable legal
                            mechanisms to challenge any such demand for access to Personal
                            Data which is under the data importer&rsquo;s control.
                            Notwithstanding the above, (a) the data exporter acknowledges that
                            such challenge may not always be reasonable or possible in light
                            of the nature, scope, context and purposes of the intended
                            government authority access, and (b) if, taking into account the
                            nature, scope, context and purposes of the intended government
                            authority access to Personal Data, the data importer has a
                            reasonable and good-faith belief that urgent access is necessary
                            to prevent an imminent risk of serious harm to any individual or
                            entity, this subsection (e)(II) shall not apply. In such event,
                            the data importer shall notify the data exporter, as soon as
                            possible, following the access by the government authority, and
                            provide the data exporter with relevant details of the same,
                            unless and to the extent legally prohibited to do so.
                        </span>
                    </li>
                </ol>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Once in every 12-month period, the data importer will inform the
                            data exporter, at the data exporter&rsquo;s written request, of
                            the types of binding legal demands for Personal Data it has
                            received and solely to the extent such demands have been received,
                            including national security orders and directives, which shall
                            encompass any process issued under section 702 of FISA.
                        </span>
                    </li>
                </ol>
            </LongCopy>
        </Layout>
    );
}
